import T from "../theme";

export function Section({ id, children, style = {} }) {
  return (
    <section
      id={id}
      style={{
        minHeight: "100vh",
        position:  "relative",
        background: T.bg1,
        ...style,
      }}
    >
      {children}
    </section>
  );
}

export function SectionLabel({ text }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14 }}>
      <div style={{ width: 28, height: 1, background: T.blue }} />
      <span
        style={{
          fontFamily:    T.mono,
          fontSize:      10,
          color:         T.blue,
          letterSpacing: 3,
          textTransform: "uppercase",
        }}
      >
        {text}
      </span>
    </div>
  );
}
